import { Typography } from '@mui/material';
import { ROUTE_MY_DATA_SETS } from 'js/constants/pathnames';
import {
  DataSetSplitFallback,
  DataSetSplitModes,
  FALLBACK_NEW_NEXSET,
} from 'new/components/SplitDataSet/DataSetSplitDialog';
import useSplitDataSet from 'new/components/SplitDataSet/useSplitDataSet';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import React from 'react';
import { Link } from 'react-router-dom';

export default function DataSetSplitRecipeTab({
  data,
  splitterDataSet,
}: {
  data: any;
  splitterDataSet: any;
}) {
  const { mode, expressions, attr, values, fallback } = useSplitDataSet(null, splitterDataSet);

  // if this is a child of a splitter, highlight the rule corresponding to this
  // Nexset
  const isSplitterChild = data.id !== splitterDataSet.id;
  const fallbackDataSetId =
    splitterDataSet?.transform?.transforms?.[0]?.spec?.fallback_destination?.id;

  return (
    <div className="configure-recipe configure-recipe-splitter">
      <div className="configure-recipe-body">
        {isSplitterChild && (
          <Typography
            variant="body2"
            style={{ display: 'block', marginBottom: 'var(--spacing-lg)' }}
          >
            This Nexset was created by Splitter{' '}
            <Link
              to={`${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}/${splitterDataSet.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              #{splitterDataSet.id}
            </Link>
            . The matching rule is highlighted below.
          </Typography>
        )}
        <ol className="recipe-groups-list">
          <li className="recipe-group">
            <DataSetSplitModes
              isReadOnly
              highlightedId={isSplitterChild ? data.id : null}
              mode={mode}
              expressions={expressions}
              attr={attr}
              values={values}
            />

            <DataSetSplitFallback
              isReadOnly
              isHighlighted={
                isSplitterChild && fallback === FALLBACK_NEW_NEXSET && fallbackDataSetId === data.id
              }
              fallback={fallback}
            />
          </li>
        </ol>
      </div>
    </div>
  );
}
